// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e4b4ee29","389":"a0db22f7","732":"98a694c1","854":"5a230d7b","977":"daeb9a6e"}[chunkId] + ".chunk.js";
};